import { render, staticRenderFns } from "./Panel_White.vue?vue&type=template&id=6cd37fa4&"
import script from "./Panel_White.vue?vue&type=script&lang=js&"
export * from "./Panel_White.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports